import { render, staticRenderFns } from "./CommentAccount.vue?vue&type=template&id=76ccc5c3"
import script from "./CommentAccount.vue?vue&type=script&lang=js"
export * from "./CommentAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports